// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    react/prefer-stateless-function
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import DataConnector from 'connect/DataConnector';
import * as CrisprConstants from 'constants/CRISPRConstants';
import {CRISPRVector} from 'constants/CRISPRConstants';
import CRISPRAssemblyTabState from 'molbio/crispr/assembly/CRISPRAssemblyTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import CompletedAssemblyStep from './CompletedAssemblyStep';
import CRISPRAssemblyStore, {CRISPRAssemblyState} from './CRISPRAssemblyStore';
import FinalizeAssembliesStep from './FinalizeAssembliesStep';
import SelectVectorStep from './SelectVectorStep';

const {ASSEMBLY_STEP} = CrisprConstants;

class CRISPRAssemblyOptions extends React.Component {
  render(): JSX.Element {
    return <ul className="nav navbar-nav form-inline" />;
  }
}

class CRISPRAssemblyOptionsView extends Backbone.View<CRISPRAssemblyTabState> {
  static initClass(): void {
    this.prototype.className = 'navbar';
  }

  render(): this {
    renderToDOM(<CRISPRAssemblyOptions />, this.el);
    return this;
  }
}
CRISPRAssemblyOptionsView.initClass();

class CRISPRAssemblyTabConnector extends DataConnector<
  CRISPRAssemblyTabProps,
  CRISPRAssemblyTabEnhancedProps
> {
  shouldSubscribeToRedux = false;
  stores = [CRISPRAssemblyStore];

  enhanceProps(): CRISPRAssemblyTabEnhancedProps {
    return {
      ...this.crisprAssemblyStore().getAssemblyState(this.props.assemblyCid),
      ...this.crisprAssemblyStore().getState(),
    };
  }
}

interface CRISPRAssemblyTabProps {
  assemblyCid: string;
  sequenceName: string;
}
interface CRISPRAssemblyTabEnhancedProps extends CRISPRAssemblyState {
  vectors: Array<CRISPRVector>;
  vectorLoading: boolean;
}

class CRISPRAssemblyTab extends React.Component<CRISPRAssemblyTabProps & CRISPRAssemblyTabEnhancedProps> {
  render(): JSX.Element {
    return (
      <div>
        {(() => {
          switch (this.props.step) {
            case ASSEMBLY_STEP.SELECT_VECTOR:
              return (
                <SelectVectorStep
                  assemblyCid={this.props.assemblyCid}
                  vectors={this.props.vectors}
                  vectorLoading={this.props.vectorLoading}
                  biojsSequence={this.props.biojsSequence}
                  enzyme={this.props.enzyme}
                  existingSequenceInputState={this.props.existingSequenceInputState}
                  fileInputState={this.props.fileInputState}
                  finalizingSelectedVector={this.props.finalizingSelectedVector}
                  // @ts-expect-error: unclear if values are allowed to be null or not at this point
                  insertionRegion={this.props.insertionRegion}
                  vectorSelectorState={this.props.vectorSelectorState}
                  vectorSourceType={this.props.vectorSourceType}
                />
              );
            case ASSEMBLY_STEP.FINALIZE_ASSEMBLIES:
              return (
                <FinalizeAssembliesStep
                  analysis={this.props.analysis}
                  assemblyCid={this.props.assemblyCid}
                  assemblies={this.props.assemblies}
                  assembliesFolder={this.props.assembliesFolder}
                  finalizingAssemblies={this.props.finalizingAssemblies}
                />
              );
            case ASSEMBLY_STEP.COMPLETED_ASSEMBLY:
              return (
                <CompletedAssemblyStep
                  assemblyCid={this.props.assemblyCid}
                  assemblyPrimers={this.props.assemblyPrimers}
                  sequenceName={this.props.sequenceName}
                />
              );
            default:
              return null;
          }
        })()}
      </div>
    );
  }
}

const ConnectedCRISPRAssemblyTab = CRISPRAssemblyTabConnector.connect(CRISPRAssemblyTab);

class CRISPRAssemblyTabView extends Backbone.View<CRISPRAssemblyTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab-reset';
  }

  render(): this {
    renderToDOM(
      <ConnectedCRISPRAssemblyTab
        assemblyCid={this.model.assemblyCid()}
        sequenceName={this.model.sequenceName()}
      />,
      this.el
    );
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
CRISPRAssemblyTabView.initClass();

export {CRISPRAssemblyOptionsView, CRISPRAssemblyTabView};
